import { CLEAR_GIVEAWAYS } from 'root/src/client/logic/api/actionIds';
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId';
import { apiStoreLenses } from 'root/src/client/logic/api/lenses';
const { setGiveaway } = apiStoreLenses;
export const giveawayReducer = {
    [CLEAR_GIVEAWAYS]: (state) => {
        const recordId = currentRouteParamsRecordId(state);
        if (!recordId) {
            return state;
        }
        return setGiveaway([], state);
    },
};
